import { autocompleteClasses } from "@mui/material/Autocomplete";
import { styled } from "@mui/material";
import ListItem from "components/primitives/ListItem";
import List from "components/primitives/List";

const GroupItem = styled(ListItem)({
  boxSizing: "border-box",
  position: "absolute",
  left: 0,
  width: "100%",
  display: "block",
  margin: 0,
  padding: 0,
});

// Mirrors Autocomplete's own GroupUl, which MUI does not export.
const GroupList = styled(List, { name: "MuiAutocomplete", slot: "GroupUl" })({
  padding: 0,
  [`& .${autocompleteClasses.option}`]: {
    paddingLeft: 24,
  },
});

interface ListboxGroupProps {
  /** Id of the group's header, which may be unmounted by virtualization. */
  labelledBy: string;
  /**
   * The group's own label text. Once the header row is unmounted, `labelledBy`
   * points at nothing and the name computation falls through to this.
   */
  label: string;
  /** Offset and height of the whole group, header included, in px. */
  start: number;
  size: number;
  header?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * One group, shaped like Autocomplete's own: an item holding the header and a
 * nested list of options. The item spans the group's full height so a sticky
 * header stays pinned until its group scrolls away, and its options are placed
 * relative to it.
 */
function ListboxGroup({ labelledBy, label, start, size, header, children }: ListboxGroupProps) {
  return (
    <GroupItem role="presentation" style={{ top: start, height: size }}>
      {header}
      <GroupList role="group" aria-labelledby={labelledBy} aria-label={label} className={autocompleteClasses.groupUl}>
        {children}
      </GroupList>
    </GroupItem>
  );
}

export default ListboxGroup;
